import React from 'react';
import { motion } from 'framer-motion';
import { FaHeart, FaHandshake, FaLightbulb, FaUsers } from 'react-icons/fa';

function About() {
  const values = [
    {
      icon: <FaHeart />,
      title: "Passion",
      description: "We're passionate about creating exceptional spaces that inspire."
    },
    {
      icon: <FaHandshake />,
      title: "Integrity",
      description: "Trust and transparency in every project we undertake."
    },
    {
      icon: <FaLightbulb />,
      title: "Innovation",
      description: "Bringing creative solutions to complex challenges."
    },
    {
      icon: <FaUsers />,
      title: "Teamwork",
      description: "Collaborative approach for the best results."
    }
  ];

  const timeline = [
    {
      year: "2022",
      title: "Company Founded",
      description: "Griffith & McKee was established with a vision for excellence."
    },
    {
      year: "2023",
      title: "Major Expansion",
      description: "Expanded services to include commercial projects."
    },
    {
      year: "2024",
      title: "Industry Recognition",
      description: "Received multiple awards for outstanding projects."
    },
    {
      year: "2025",
      title: "Innovation Leader",
      description: "Pioneering sustainable construction practices."
    }
  ];

  const team = [
    {
      name: "Adam Griffith",
      role: "Co-Founder",
      image: "./images/placeholder.png",
      description: "30+ years of construction expertise"
    },
    {
      name: "Logan McKee",
      role: "Co-Founder",
      image: "./images/placeholder.png",
      description: "Expert in project management"
    }
  ];

  return (
    <div className="about-container">
      {/* Hero Section */}
      <motion.section 
        className="about-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <div className="about-hero-content">
          <motion.h1
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.5 }}
          >
            About Griffith & McKee
          </motion.h1>
          <motion.p
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            transition={{ delay: 0.7 }}
          >
            Building excellence since 2022. We transform spaces and create lasting value
            through innovative design and quality craftsmanship.
          </motion.p>
        </div>
      </motion.section>

      {/* Values Section */}
      <section className="values-section">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Our Core Values
        </motion.h2>
        <div className="values-grid">
          {values.map((value, index) => (
            <motion.div
              key={index}
              className="value-card"
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
            >
              <div className="value-icon">{value.icon}</div>
              <h3>{value.title}</h3>
              <p>{value.description}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Timeline Section */}
      <section className="timeline-section">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Our Journey
        </motion.h2>
        <div className="timeline">
          {timeline.map((item, index) => (
            <motion.div
              key={index}
              className="timeline-item"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.3 }}
            >
              <div className="timeline-content">
                <span className="year">{item.year}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Team Section */}
      <section className="team-section">
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          Meet Our Team
        </motion.h2>
        <div className="team-grid">
          {team.map((member, index) => (
            <motion.div
              key={index}
              className="team-card"
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.2 }}
              whileHover={{ y: -10 }}
            >
              <div className="team-image" style={{ backgroundImage: `url(${member.image})` }} />
              <h3>{member.name}</h3>
              <span className="role">{member.role}</span>
              <p>{member.description}</p>
            </motion.div>
          ))}
        </div>
      </section>
    </div>
  );
}

export default About;